import { jsx as _jsx } from "react/jsx-runtime";
export function MarkerDef(props) {
    return (_jsx("defs", { children: _jsx("marker", { id: "arrowhead", markerWidth: "10", markerHeight: "7", refX: "10", refY: "3.5", orient: "auto", children: _jsx("polygon", { points: "0 0, 10 3.5, 0 7" }) }) }));
}
//# sourceMappingURL=MarkerDef.js.map